import { render, staticRenderFns } from "./addShopDrawer.vue?vue&type=template&id=47a32f28&scoped=true"
import script from "./addShopDrawer.vue?vue&type=script&lang=js"
export * from "./addShopDrawer.vue?vue&type=script&lang=js"
import style0 from "./addShopDrawer.vue?vue&type=style&index=0&id=47a32f28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a32f28",
  null
  
)

export default component.exports